// GENERATED FILE — do not edit by hand. See scripts/build-palettes.mjs.

export interface PaletteOption {
  id: string;
  label: string;
  /** A representative colour for the swatch, taken from the palette's dark primary. */
  swatch: string;
}

export const PALETTES: PaletteOption[] = [
  { id: "amber-minimal", label: "Amber Minimal", swatch: "oklch(0.7686 0.1647 70.0804)" },
  { id: "caffeine", label: "Caffeine", swatch: "oklch(0.9247 0.0524 66.1732)" },
  { id: "clean-slate", label: "Clean Slate", swatch: "oklch(0.6801 0.1583 276.9349)" },
  { id: "crimson", label: "Crimson", swatch: "oklch(0.59 0.09 239.95)" },
  { id: "modern-minimal", label: "Modern Minimal", swatch: "oklch(0.6231 0.1880 259.8145)" },
  { id: "northern-lights", label: "Northern Lights", swatch: "oklch(0.6487 0.1538 150.3071)" },
  { id: "solar-dusk", label: "Solar Dusk", swatch: "oklch(0.7049 0.1867 47.6044)" },
  { id: "virtuallife-dimmed", label: "Virtuallife Dimmed", swatch: "oklch(0.55 0.19 300)" },
  { id: "virtuallife-v2", label: "Virtuallife V2", swatch: "oklch(0.60 0.22 300)" },
  { id: "virtuallife", label: "Virtuallife", swatch: "oklch(0.60 0.22 300)" },
];
